import { Formatter } from "utils/formatters";
import { OtherGuestsForm } from "../ReservationForm";

type FormItemProps = {
  value: OtherGuestsForm;
  set: (value: OtherGuestsForm) => void;
};

export const FormItem = ({ set, value }: FormItemProps) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <div>
        <label
          htmlFor="name"
          className="block text-sm font-medium text-neutral-900 dark:text-neutral-200"
        >
          Nome Completo
        </label>
        <input
          type="text"
          name="name"
          id="name"
          value={value.name}
          onChange={(e) => set({ ...value, name: e.target.value })}
          className="w-full border border-neutral-200 dark:border-neutral-700 rounded-md py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="age"
          className="block text-sm font-medium text-neutral-900 dark:text-neutral-200"
        >
          Data de Nascimento
        </label>

        <input
          type="date"
          name="age"
          id="age"
          value={value.birth_date}
          onChange={(e) => set({ ...value, birth_date: e.target.value })}
          className="w-full border border-neutral-200 dark:border-neutral-700 rounded-md py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="cpf"
          className="block text-sm font-medium text-neutral-900 dark:text-neutral-200"
        >
          CPF
        </label>
        <input
          type="text"
          name="cpf"
          id="cpf"
          value={value.cpf}
          onChange={(e) =>
            set({ ...value, cpf: Formatter.prettyCPF(e.target.value) })
          }
          className="w-full border border-neutral-200 dark:border-neutral-700 rounded-md py-2 px-3"
        />
      </div>
    </div>
  );
};
